import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

if (environment.host === 'prod' || environment.host === 'staging') {
    console.log('Sentry configuration ok...');
    Sentry.init({
        dsn: environment.sentry_dsn,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        beforeSend(event, hint) {
            // Ottieni il messaggio di errore
            const errorMessage = hint?.originalException?.toString() || '';

            // Filtra errori specifici
            if (errorMessage.includes('ResizeObserver loop')) {
                return null; // Sentry ignora l'errore
            }

            return event; // Altri errori vengono inviati
        },
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'https://stagingpartners.myklaro.com', 'https://partners.myklaro.com'],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
